/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Group_ByInputs */

const en_view_group_by = /** @type {(inputs: View_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group by`)
};

const de_view_group_by = /** @type {(inputs: View_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppieren nach`)
};

/**
* | output |
* | --- |
* | "Group by" |
*
* @param {View_Group_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const view_group_by = /** @type {((inputs?: View_Group_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Group_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_view_group_by(inputs)
	return en_view_group_by(inputs)
});